export type WebClientConfig = {
    agGridLicenseKey?: string;
    azureDashboardUrl: string;
    commonLibraryApiUrl: string;
    reportErrorUrl: string;
    signalRUrlMyReleases: string;
    signalRUrlNotification: string;
    signalRUrlRelease: string;
    signalRUrlShipping: string;
    technicalDocUrl: string;
};

export const getWebClientConfig = async (): Promise<WebClientConfig | undefined> => {
    const response = await fetch('/Configuration/FrontEnd');
    if (response.ok) {
        const config = await response.json();
        return {
            agGridLicenseKey: config.agGridLicenseKey,
            azureDashboardUrl: config.azureDashboardUrl,
            commonLibraryApiUrl: config.commonLibraryApiUrl,
            reportErrorUrl: config.reportErrorUrl,
            signalRUrlMyReleases: config.signalRUrlMyReleases,
            signalRUrlNotification: config.signalRUrlNotification,
            signalRUrlRelease: config.signalRUrlRelease,
            signalRUrlShipping: config.signalRUrlShipping,
            technicalDocUrl: config.technicalDocUrl
        };
    }
};

export type AzureConfig = {
    instance: string;
    tenant: string;
    clientId: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
};

export const getAzureConfiguration = async (): Promise<AzureConfig | undefined> => {
    const response = await fetch('/Configuration/Azure');
    if (response.ok) {
        const config = await response.json();
        return {
            instance: config.instance,
            tenant: config.tenantId,
            clientId: config.clientId,
            redirectUri: config.redirectUri,
            postLogoutRedirectUri: window.location.origin
        };
    }
};
